import { IResponse, IWatchList } from '@kattana-io/common';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { LOG_OUT, SetAuthPayload, SET_AUTH } from '../actions/auth';
import { actionShowModal } from '../actions/modal';
import { actionCreateNotification } from '../actions/notifications';
import { actionMergePriceChanges } from '../actions/price_changes';
import {
  actionAddSuccessWatchlist,
  actionRefreshWatchlist,
  actionRemoveSuccessWatchlist,
  ADD,
  REMOVE,
} from '../actions/watchlist';
import { IStore } from '../reducers';
import { ModalTypes } from '../reducers/modal';
import { authTokenSelector } from '../selectors/auth';
import { KattanaAPI, WatchListAPI } from '../store/createStore';

function* onAuth(action: any): any {
  try {
    const data = action.payload as SetAuthPayload;
    const token = yield select(authTokenSelector);
    if (data.loggedIn && data.wallet && data.network) {
      const res: IResponse<IWatchList> = yield call(
        WatchListAPI.get,
        data.network,
        data.wallet,
        token
      );

      if (res.success && res.data) {
        const { yesterday_prices, pairs } = res.data;
        if (yesterday_prices) {
          yield put(actionMergePriceChanges(yesterday_prices));
        }
        if (Array.isArray(pairs)) {
          yield put(actionRefreshWatchlist(res.data.pairs));
        }
      } else {
        yield put(actionRefreshWatchlist([]));
      }
    }
  } catch (error) {
    yield put(actionCreateNotification({ kind: 'warning', message: error }));
    console.error(error);
    yield put(actionRefreshWatchlist([]));
  }
}

function* onAdd(action: any): any {
  try {
    const token = yield select(authTokenSelector);
    const { loggedIn, wallet, network } = yield select(
      (store: IStore) => store.auth
    );

    if (!loggedIn) {
      // show connect modal
      yield put(actionShowModal(ModalTypes.connect, {}));
      return;
    }

    const res: IResponse<any> = yield call(
      WatchListAPI.addPair,
      network,
      wallet,
      action.payload.id,
      token
    );
    if (res.success) {
      const resTickers: any = yield call(
        KattanaAPI.tickersByIds,
        `${action.payload.id}`,
        {}
      );
      yield put(actionAddSuccessWatchlist(resTickers[0]));
    }
  } catch (error) {
    yield put(actionCreateNotification({ kind: 'warning', message: error }));
    console.error(error);
  }
}

function* onRemove(action: any): any {
  try {
    const token = yield select(authTokenSelector);
    const { loggedIn, wallet, network } = yield select(
      (store: IStore) => store.auth
    );

    const res: IResponse<any> = yield call(
      WatchListAPI.remove,
      network,
      wallet,
      action.payload,
      token
    );

    if (res.success) {
      yield put(actionRemoveSuccessWatchlist(action.payload));
    }
  } catch (error) {
    yield put(actionCreateNotification({ kind: 'warning', message: error }));
    console.error(error);
  }
}

function* onLogOut(action: any): any {
  try {
    yield put(actionRefreshWatchlist([]));
  } catch (error) {
    console.error(error);
  }
}

export default function* watchListSaga() {
  yield takeLatest(SET_AUTH, onAuth);
  yield takeLatest(LOG_OUT, onLogOut);
  yield takeLatest(ADD, onAdd);
  yield takeLatest(REMOVE, onRemove);
}
